// Massimo numero di tentativi aggiuntivi dopo la prima richiesta fallita.
// `retry: true` di react-query significa retry infinito: usare sempre questa costante.
export const MAX_API_RETRIES = 3;
